/* ==========================================================================
   Ostrich Golf — JavaScript global del tema
   Vanilla JS, sin dependencias. Módulos:
     1. Utilidades y rutas
     2. CartAPI        — añadir / cambiar / leer el carrito vía AJAX
     3. Contadores     — [data-cart-count] en vivo
     4. Cart drawer    — panel lateral (sección estática `cart-drawer`)
     5. Quick add      — formularios [data-ajax-add] sin recarga
     5 bis. Tarjeta    — swatches de color y panel de tallas del «+»
     6. Steppers       — botones [data-qty-minus] / [data-qty-plus]
     7. Página carrito — [data-cart-main]: cantidades y eliminación en vivo
     8. Buscador       — modal con coincidencia aproximada (no literal)
     9. Localización   — desplegables de país/divisa e idioma
   ========================================================================== */
(function () {
  'use strict';

  /* ----------------------------------------------------------------------
     1. Utilidades
  ---------------------------------------------------------------------- */
  var routes = window.theme && window.theme.routes ? window.theme.routes : {};
  var cartUrl = routes.cart_url || '/cart';
  var rootUrl = routes.root_url || '/';
  if (rootUrl.slice(-1) !== '/') rootUrl += '/';
  var settings = window.theme && window.theme.settings ? window.theme.settings : {};
  var strings = window.theme && window.theme.strings ? window.theme.strings : {};

  function $(selector, context) {
    return (context || document).querySelector(selector);
  }
  function $$(selector, context) {
    return Array.prototype.slice.call((context || document).querySelectorAll(selector));
  }
  function dispatch(name, detail) {
    document.dispatchEvent(new CustomEvent(name, { detail: detail || {} }));
  }
  function parseHTML(text) {
    return new DOMParser().parseFromString(text, 'text/html');
  }

  /* ----------------------------------------------------------------------
     2. CartAPI
  ---------------------------------------------------------------------- */
  var CartAPI = {
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },

    get: function () {
      return fetch(cartUrl + '.js', { headers: this.headers }).then(function (r) {
        return r.json();
      });
    },

    add: function (formDataOrItems) {
      var options;
      if (formDataOrItems instanceof FormData) {
        options = { method: 'POST', body: formDataOrItems };
      } else {
        options = {
          method: 'POST',
          headers: this.headers,
          body: JSON.stringify({ items: formDataOrItems })
        };
      }
      return fetch(cartUrl + '/add.js', options).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      });
    },

    change: function (payload) {
      return fetch(cartUrl + '/change.js', {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify(payload)
      }).then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw data;
          return data;
        });
      });
    },

    updateNote: function (note) {
      return fetch(cartUrl + '/update.js', {
        method: 'POST',
        headers: this.headers,
        body: JSON.stringify({ note: note })
      }).then(function (r) {
        return r.json();
      });
    }
  };
  window.CartAPI = CartAPI;

  /* ----------------------------------------------------------------------
     3. Contadores de carrito
  ---------------------------------------------------------------------- */
  function updateCartCount(count) {
    $$('[data-cart-count]').forEach(function (el) {
      el.textContent = count;
    });
  }

  /* ----------------------------------------------------------------------
     4. Cart drawer
  ---------------------------------------------------------------------- */
  var drawer = {
    root: null,
    lastFocus: null,

    init: function () {
      this.root = $('[data-cart-drawer]');
      if (!this.root) return;

      var self = this;

      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-cart-drawer-open]');
        if (opener && settings.cart_type === 'drawer') {
          event.preventDefault();
          self.open();
          return;
        }
        if (event.target.closest('[data-cart-drawer-close]')) {
          event.preventDefault();
          self.close();
        }
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && self.isOpen()) self.close();
      });
    },

    isOpen: function () {
      return this.root && !this.root.classList.contains('pointer-events-none');
    },

    open: function () {
      if (!this.root) return;
      this.lastFocus = document.activeElement;
      this.root.classList.remove('pointer-events-none');
      this.root.setAttribute('aria-hidden', 'false');
      var overlay = $('[data-drawer-overlay]', this.root);
      var panel = $('[data-drawer-panel]', this.root);
      if (overlay) overlay.classList.remove('opacity-0');
      if (panel) panel.classList.remove('translate-x-full');
      document.documentElement.classList.add('overflow-hidden');
      var closeBtn = $('[data-cart-drawer-close]', this.root);
      if (closeBtn) closeBtn.focus();
    },

    close: function () {
      if (!this.root) return;
      var overlay = $('[data-drawer-overlay]', this.root);
      var panel = $('[data-drawer-panel]', this.root);
      if (overlay) overlay.classList.add('opacity-0');
      if (panel) panel.classList.add('translate-x-full');
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('overflow-hidden');
      var self = this;
      window.setTimeout(function () {
        self.root.classList.add('pointer-events-none');
      }, 320);
      if (this.lastFocus) this.lastFocus.focus();
    },

    refresh: function () {
      var self = this;
      if (!this.root) return Promise.resolve();
      return fetch(rootUrl + '?section_id=cart-drawer')
        .then(function (r) {
          return r.text();
        })
        .then(function (text) {
          var fresh = $('[data-cart-drawer]', parseHTML(text));
          if (!fresh) return;
          var currentInner = $('[data-drawer-inner]', self.root);
          var freshInner = $('[data-drawer-inner]', fresh);
          if (currentInner && freshInner) currentInner.innerHTML = freshInner.innerHTML;
        });
    }
  };

  /* ----------------------------------------------------------------------
     Refresco global tras cualquier mutación del carrito
  ---------------------------------------------------------------------- */
  function refreshCart(openDrawer) {
    return Promise.all([CartAPI.get(), drawer.refresh(), refreshCartPage()]).then(function (results) {
      var cart = results[0];
      updateCartCount(cart.item_count);
      dispatch('cart:updated', { cart: cart });
      if (openDrawer && settings.cart_type === 'drawer') drawer.open();
      return cart;
    });
  }

  /* ----------------------------------------------------------------------
     5. Quick add — formularios de producto con [data-ajax-add]
  ---------------------------------------------------------------------- */
  function initAjaxAdd() {
    document.addEventListener('submit', function (event) {
      var form = event.target.closest('form[data-ajax-add]');
      if (!form) return;
      event.preventDefault();

      /* En las tarjetas con tallas el botón que confirma vive fuera del form
         (dentro del panel), así que lo pasa `initCardVariants`. */
      var button = form.__submitter || form.querySelector('[type="submit"]');
      var card = form.closest('[data-product-card]');
      var errorBox = $('[data-form-error]', form.closest('[data-product-form-wrapper]') || form);
      if (errorBox) {
        errorBox.textContent = '';
        errorBox.classList.add('hidden');
      }
      if (button) {
        button.setAttribute('aria-busy', 'true');
        button.classList.add('opacity-50', 'pointer-events-none');
      }

      CartAPI.add(new FormData(form))
        .then(function () {
          if (card) resetCardSize(card);
          return refreshCart(true);
        })
        .then(function () {
          if (settings.cart_type !== 'drawer') window.location.href = cartUrl;
        })
        .catch(function (error) {
          var message = (error && (error.description || error.message)) || strings.cart_error || 'No se pudo añadir el producto.';
          if (errorBox) {
            errorBox.textContent = message;
            errorBox.classList.remove('hidden');
          } else {
            window.alert(message);
          }
        })
        .finally(function () {
          delete form.__submitter;
          if (button) {
            button.removeAttribute('aria-busy');
            button.classList.remove('opacity-50', 'pointer-events-none');
          }
        });
    });
  }

  /* ----------------------------------------------------------------------
     5 bis. Tarjeta de producto — swatches y panel de tallas
     `snippets/product-card.liquid` puede llevar dos selectores:
       · swatches de color → [data-card-swatch]
       · panel de tallas   → [data-card-size] dentro de [data-card-size-panel]
     Los dos escriben sobre la misma «selección» de la tarjeta: un array con
     el valor elegido para cada índice de opción (null = todavía sin elegir).
     La talla arranca siempre en null, así que hay que elegirla antes de que
     aparezca el botón «Añadir»: seleccionar → confirmar.
     El aspecto del panel (velo, hoja, escalonado de los chips, despliegue
     del CTA) es CSS puro (main.css → «Panel de tallas»): aquí solo se ponen
     y quitan atributos: `data-open` y `data-ready` en el panel, `aria-pressed`
     y `disabled` en los chips.
  ---------------------------------------------------------------------- */

  function cardVariants(card) {
    if (card.__variants !== undefined) return card.__variants;
    var node = $('[data-card-variants]', card);
    try {
      card.__variants = node ? JSON.parse(node.textContent) : null;
    } catch (error) {
      card.__variants = null;
    }
    return card.__variants;
  }

  /* Índice de la opción de talla, leído del primer botón del panel. -1 = la
     tarjeta no tiene panel de tallas. */
  function cardSizeIndex(card) {
    if (card.__sizeIndex !== undefined) return card.__sizeIndex;
    var button = $('[data-card-size]', card);
    var index = button ? parseInt(button.dataset.optionIndex, 10) : NaN;
    card.__sizeIndex = isNaN(index) ? -1 : index;
    return card.__sizeIndex;
  }

  function cardSelection(card) {
    if (card.__selection) return card.__selection;
    var variants = cardVariants(card) || [];
    var idInput = $('[data-card-variant-id]', card);
    var id = idInput ? parseInt(idInput.value, 10) : 0;
    var current =
      variants.filter(function (variant) {
        return variant.id === id;
      })[0] || variants[0];

    card.__selection = current ? current.options.slice() : [];
    var sizeIndex = cardSizeIndex(card);
    if (sizeIndex > -1) card.__selection[sizeIndex] = null;
    return card.__selection;
  }

  function matchesSelection(variant, selection) {
    return selection.every(function (value, index) {
      return value == null || variant.options[index] === value;
    });
  }

  /* Variante que representa la selección actual. Si la combinación exacta no
     existe (esa talla no viene en ese color), se relaja la talla para poder
     seguir mostrando precio e imagen del color elegido. */
  function resolveCardVariant(card) {
    var variants = cardVariants(card);
    if (!variants || !variants.length) return null;

    var selection = cardSelection(card);
    var pool = variants.filter(function (variant) {
      return matchesSelection(variant, selection);
    });

    if (!pool.length) {
      var relaxed = selection.slice();
      var sizeIndex = cardSizeIndex(card);
      if (sizeIndex > -1) relaxed[sizeIndex] = null;
      pool = variants.filter(function (variant) {
        return matchesSelection(variant, relaxed);
      });
    }
    if (!pool.length) pool = variants;

    var available = pool.filter(function (variant) {
      return variant.available;
    });
    return available[0] || pool[0];
  }

  /* Estado del panel: qué tallas hay para el color elegido, cuál está marcada
     y junto a cuál se enseña el botón «Añadir». */
  function renderCardSizes(card) {
    var sizeIndex = cardSizeIndex(card);
    if (sizeIndex === -1) return;

    var variants = cardVariants(card) || [];
    var selection = cardSelection(card);

    var chosen = selection[sizeIndex];
    var ready = false;

    $$('[data-card-size]', card).forEach(function (button) {
      var probe = selection.slice();
      probe[sizeIndex] = button.dataset.value;
      var match = variants.filter(function (variant) {
        return matchesSelection(variant, probe);
      })[0];

      var active = chosen === button.dataset.value;
      button.disabled = !match || !match.available;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      if (active && !button.disabled) ready = true;
    });

    /* Un solo CTA para todo el panel: se despliega (CSS, data-ready) cuando
       hay talla elegida y disponible, y enseña cuál es. Plegado no se puede
       tabular hasta él: está recortado por overflow, se vería el foco perdido. */
    var panel = $('[data-card-size-panel]', card);
    var addButton = $('[data-card-size-add]', card);
    var sizeLabel = $('[data-card-size-add-size]', card);
    if (panel) panel.toggleAttribute('data-ready', ready);
    if (sizeLabel) sizeLabel.textContent = ready ? chosen : '';
    if (addButton) {
      addButton.tabIndex = ready ? 0 : -1;
      addButton.setAttribute('aria-hidden', ready ? 'false' : 'true');
    }
  }

  /* Refresca toda la tarjeta a partir de la selección actual. */
  function renderCard(card) {
    var variant = resolveCardVariant(card);
    if (!variant) return;
    var selection = cardSelection(card);

    /* Swatches */
    $$('[data-card-swatch]', card).forEach(function (swatch) {
      var index = parseInt(swatch.dataset.optionIndex, 10) || 0;
      var active = selection[index] === swatch.dataset.value;
      swatch.setAttribute('aria-pressed', active ? 'true' : 'false');
      swatch.classList.toggle('outline-stone-400', active);
      swatch.classList.toggle('outline-transparent', !active);
      swatch.classList.toggle('hover:outline-stone-300', !active);
    });

    /* Precio */
    var priceEl = $('[data-card-price]', card);
    var compareEl = $('[data-card-compare]', card);
    if (priceEl) {
      priceEl.textContent = variant.price;
      priceEl.classList.toggle('text-brand-900', !!variant.compare);
    }
    var panelPriceEl = $('[data-card-size-price]', card);
    if (panelPriceEl) panelPriceEl.textContent = variant.price;
    if (compareEl) {
      compareEl.textContent = variant.compare || '';
      compareEl.classList.toggle('hidden', !variant.compare);
    }

    /* Imagen: si la variante tiene la suya, sustituye a la principal y se
       oculta la de hover (sería la de otro color). Solo si cambia de verdad,
       para no romper el hover al elegir una talla del mismo color. */
    var imageEl = $('[data-card-image]', card);
    var hoverEl = $('[data-card-hover-image]', card);
    if (imageEl && variant.image && imageEl.getAttribute('src') !== variant.image) {
      imageEl.src = variant.image;
      imageEl.removeAttribute('srcset');
      if (hoverEl) {
        hoverEl.classList.add('hidden');
        imageEl.classList.remove('group-hover:opacity-0');
      }
    }

    /* Enlaces y variante que se añadirá */
    $$('[data-card-url]', card).forEach(function (link) {
      link.href = link.dataset.cardUrl + '?variant=' + variant.id;
    });

    var idInput = $('[data-card-variant-id]', card);
    if (idInput) idInput.value = variant.id;

    /* El «+» de una tarjeta con tallas abre el panel: nunca se deshabilita. */
    var addButton = $('[data-card-add]', card);
    if (addButton && !addButton.hasAttribute('data-card-size-toggle')) {
      addButton.disabled = !variant.available;
    }

    renderCardSizes(card);
  }

  function toggleSizePanel(card, open) {
    var panel = $('[data-card-size-panel]', card);
    if (!panel) return;
    var toggle = $('[data-card-size-toggle]', card);
    var icon = $('[data-card-add-icon]', card);

    if (open) {
      panel.removeAttribute('inert');
      panel.setAttribute('data-open', '');
    } else {
      /* El foco no puede quedarse dentro de algo `inert`. */
      if (panel.contains(document.activeElement) && toggle) toggle.focus();
      panel.removeAttribute('data-open');
      panel.setAttribute('inert', '');
    }

    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (icon) icon.classList.toggle('rotate-45', open);
    card.__panelOpen = open;
  }

  function closeSizePanels(except) {
    $$('[data-card-size-panel]').forEach(function (panel) {
      var card = panel.closest('[data-product-card]');
      if (card && card !== except && card.__panelOpen) toggleSizePanel(card, false);
    });
  }

  /* Deja la tarjeta lista para otra compra: sin talla elegida y cerrada. */
  function resetCardSize(card) {
    var sizeIndex = cardSizeIndex(card);
    if (sizeIndex === -1) return;
    cardSelection(card)[sizeIndex] = null;
    renderCardSizes(card);
    toggleSizePanel(card, false);
  }

  /* Productos hermanos (un producto por color, ver product-card.liquid):
     al elegir un color la tarjeta pasa a representar otro producto. Se
     sustituyen imagen, enlace, variante por defecto y la lista de variantes,
     y después `renderCard` recalcula precio, tallas y enlaces como siempre. */
  function cardSiblings(card) {
    if (card.__siblings !== undefined) return card.__siblings;
    var node = $('[data-card-siblings]', card);
    try {
      card.__siblings = node ? JSON.parse(node.textContent) : null;
    } catch (error) {
      card.__siblings = null;
    }
    return card.__siblings;
  }

  function applyCardSibling(card, index) {
    var siblings = cardSiblings(card);
    var sibling = siblings && siblings[index];
    if (!sibling) return;

    /* Nuevo juego de variantes y selección desde cero (la talla vuelve a null). */
    card.__variants = sibling.variants || [];
    card.__selection = undefined;

    var idInput = $('[data-card-variant-id]', card);
    if (idInput) idInput.value = sibling.variant_id;

    $$('[data-card-url]', card).forEach(function (link) {
      link.dataset.cardUrl = sibling.url;
      link.href = sibling.url;
    });

    var imageEl = $('[data-card-image]', card);
    var hoverEl = $('[data-card-hover-image]', card);
    if (imageEl && sibling.image) {
      imageEl.src = sibling.image;
      imageEl.removeAttribute('srcset');
      if (sibling.alt) imageEl.alt = sibling.alt;
    }
    if (hoverEl) {
      if (sibling.hover) {
        hoverEl.src = sibling.hover;
        hoverEl.removeAttribute('srcset');
        hoverEl.classList.remove('hidden');
        if (imageEl) imageEl.classList.add('group-hover:opacity-0');
      } else {
        hoverEl.classList.add('hidden');
        if (imageEl) imageEl.classList.remove('group-hover:opacity-0');
      }
    }

    /* Insignia «Novedad»: cada color es un producto distinto, así que puede
       ser novedad aunque el principal no lo sea (o al revés). */
    var badge = $('[data-card-badge]', card);
    if (badge) badge.hidden = !sibling.is_new;

    $$('[data-card-sibling]', card).forEach(function (button) {
      var active = parseInt(button.dataset.cardSibling, 10) === index;
      button.setAttribute('aria-pressed', active ? 'true' : 'false');
      button.classList.toggle('outline-stone-400', active);
      button.classList.toggle('outline-transparent', !active);
      button.classList.toggle('hover:outline-stone-300', !active);
    });

    renderCard(card);
  }

  function initCardVariants() {
    document.addEventListener('click', function (event) {
      var sibling = event.target.closest('[data-card-sibling]');
      if (sibling) {
        var siblingCard = sibling.closest('[data-product-card]');
        if (!siblingCard) return;
        event.preventDefault();
        applyCardSibling(siblingCard, parseInt(sibling.dataset.cardSibling, 10) || 0);
        return;
      }

      var swatch = event.target.closest('[data-card-swatch]');
      if (swatch) {
        var swatchCard = swatch.closest('[data-product-card]');
        if (!swatchCard) return;
        event.preventDefault();
        var swatchIndex = parseInt(swatch.dataset.optionIndex, 10) || 0;
        cardSelection(swatchCard)[swatchIndex] = swatch.dataset.value;
        renderCard(swatchCard);
        return;
      }

      var size = event.target.closest('[data-card-size]');
      if (size) {
        var sizeCard = size.closest('[data-product-card]');
        if (!sizeCard) return;
        event.preventDefault();
        /* Una talla agotada no se puede elegir. */
        if (size.disabled || size.getAttribute('aria-disabled') === 'true') return;
        var sizeIndex = parseInt(size.dataset.optionIndex, 10) || 0;
        var selection = cardSelection(sizeCard);
        /* Volver a pulsar la talla marcada la deselecciona. */
        selection[sizeIndex] = selection[sizeIndex] === size.dataset.value ? null : size.dataset.value;
        renderCard(sizeCard);
        return;
      }

      var confirm = event.target.closest('[data-card-size-add]');
      if (confirm) {
        var confirmCard = confirm.closest('[data-product-card]');
        var form = confirmCard ? $('form[data-ajax-add]', confirmCard) : null;
        if (!form) return;
        event.preventDefault();
        form.__submitter = confirm;
        if (typeof form.requestSubmit === 'function') form.requestSubmit();
        else form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
        return;
      }

      var toggle = event.target.closest('[data-card-size-toggle]');
      if (toggle) {
        var toggleCard = toggle.closest('[data-product-card]');
        if (!toggleCard) return;
        event.preventDefault();
        var willOpen = !toggleCard.__panelOpen;
        closeSizePanels(toggleCard);
        if (willOpen) renderCardSizes(toggleCard);
        toggleSizePanel(toggleCard, willOpen);
        return;
      }

      /* Clic fuera (o sobre el velo del propio panel): se cierra cualquier
         panel abierto. */
      if (!event.target.closest('[data-card-size-panel]') || event.target.closest('[data-card-size-veil]')) {
        closeSizePanels(null);
      }
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' || event.key === 'Esc') closeSizePanels(null);
    });

    /* Estado inicial: marcar qué tallas hay disponibles de salida. */
    refreshCardPanels();

    /* Cuando una sección se repinta por AJAX (p. ej. los filtros de colección
       en assets/collection.js) las tarjetas son nuevas: hay que repasarlas. */
    document.addEventListener('section:updated', refreshCardPanels);
  }

  function refreshCardPanels() {
    $$('[data-card-size-panel]').forEach(function (panel) {
      var card = panel.closest('[data-product-card]');
      if (card) renderCardSizes(card);
    });
  }

  /* ----------------------------------------------------------------------
     6. Steppers de cantidad
  ---------------------------------------------------------------------- */
  function initSteppers() {
    document.addEventListener('click', function (event) {
      var minus = event.target.closest('[data-qty-minus]');
      var plus = event.target.closest('[data-qty-plus]');
      if (!minus && !plus) return;

      var wrapper = (minus || plus).closest('[data-qty]');
      var input = wrapper && $('input', wrapper);
      if (!input) return;

      var value = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || (input.dataset.allowZero === 'true' ? 0 : 1);
      value = minus ? Math.max(min, value - 1) : value + 1;
      input.value = value;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* ----------------------------------------------------------------------
     7. Página del carrito + líneas del drawer
        [data-line-qty] → input con data-line (clave de línea)
        [data-line-remove] → enlace/botón con data-line
  ---------------------------------------------------------------------- */
  var cartBusy = false;

  /* Contenedores que se atenúan mientras el carrito se actualiza.
     IMPORTANTE: nunca [data-cart-drawer] (la raíz), porque su clase
     `pointer-events-none` es lo que mantiene el drawer cerrado inerte:
     quitársela dejaría un overlay invisible capturando todos los clics. */
  function busyTargets() {
    return $$('[data-cart-main], [data-drawer-inner]');
  }

  function changeLine(line, quantity) {
    if (cartBusy) return;
    cartBusy = true;
    busyTargets().forEach(function (el) {
      el.classList.add('opacity-60');
      el.setAttribute('inert', '');
    });
    CartAPI.change({ id: line, quantity: quantity })
      .then(function () {
        return refreshCart(false);
      })
      .catch(function (error) {
        var message = (error && error.description) || strings.cart_error || 'No se pudo actualizar el carrito.';
        window.alert(message);
        return refreshCart(false);
      })
      .finally(function () {
        cartBusy = false;
        busyTargets().forEach(function (el) {
          el.classList.remove('opacity-60');
          el.removeAttribute('inert');
        });
      });
  }

  function initCartLines() {
    document.addEventListener('change', function (event) {
      var input = event.target.closest('[data-line-qty]');
      if (!input) return;
      var quantity = parseInt(input.value, 10);
      if (isNaN(quantity) || quantity < 0) quantity = 0;
      changeLine(input.dataset.line, quantity);
    });

    document.addEventListener('click', function (event) {
      var remove = event.target.closest('[data-line-remove]');
      if (!remove) return;
      event.preventDefault();
      changeLine(remove.dataset.line, 0);
    });

    // Nota del pedido (guardado silencioso al escribir)
    var noteTimer;
    document.addEventListener('input', function (event) {
      var note = event.target.closest('[data-cart-note]');
      if (!note) return;
      window.clearTimeout(noteTimer);
      noteTimer = window.setTimeout(function () {
        CartAPI.updateNote(note.value);
      }, 500);
    });
  }

  function refreshCartPage() {
    var main = $('[data-cart-main]');
    if (!main) return Promise.resolve();
    return fetch(window.location.pathname + window.location.search, {
      headers: { Accept: 'text/html' }
    })
      .then(function (r) {
        return r.text();
      })
      .then(function (text) {
        var fresh = $('[data-cart-main]', parseHTML(text));
        if (fresh) main.innerHTML = fresh.innerHTML;
      });
  }

  /* ----------------------------------------------------------------------
     8. Buscador (modal) — sections/search-modal.liquid

     La coincidencia NO es literal. Se busca, por este orden:
       1. Subcadena          "up"     → "Polo C[up]"
       2. Errata (Levenshtein) "polp"  → "Polo"
       3. Subsecuencia        "plcp"   → "[P]o[l]o [C]u[p]"
     Cada palabra de la consulta tiene que encajar en algún campo (título,
     proveedor, tipo o etiquetas); si una falla, el producto se descarta.
  ---------------------------------------------------------------------- */
  var RECENT_KEY = 'ostrich:recently-viewed';

  function escapeHtml(value) {
    return String(value == null ? '' : value).replace(/[&<>"']/g, function (char) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[char];
    });
  }

  /* Pliega acentos y mayúsculas CARÁCTER A CARÁCTER para conservar la longitud:
     así el índice de una coincidencia en el texto plegado sigue siendo válido
     sobre el título original y se puede resaltar sin descuadrar. */
  function fold(text) {
    return String(text || '')
      .replace(/[^\u0000-\u007F]/g, function (char) {
        var base = char.normalize('NFD').replace(/[\u0300-\u036F]/g, '');
        return base.length === 1 ? base : char;
      })
      .toLowerCase();
  }

  /* Versión para comparar: sin puntuación y con espacios colapsados. */
  function normalize(text) {
    return fold(text)
      .replace(/[^a-z0-9\s]+/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  }

  /* Distancia de edición con corte temprano: en cuanto una fila entera supera
     `max` ya no hay vuelta atrás y devolvemos max+1 sin terminar la matriz. */
  function levenshtein(a, b, max) {
    if (a === b) return 0;
    if (Math.abs(a.length - b.length) > max) return max + 1;
    if (!a.length) return b.length;
    if (!b.length) return a.length;

    var prev = new Array(b.length + 1);
    var curr = new Array(b.length + 1);
    var i, j;

    for (j = 0; j <= b.length; j++) prev[j] = j;

    for (i = 1; i <= a.length; i++) {
      curr[0] = i;
      var best = curr[0];
      for (j = 1; j <= b.length; j++) {
        var cost = a.charAt(i - 1) === b.charAt(j - 1) ? 0 : 1;
        curr[j] = Math.min(curr[j - 1] + 1, prev[j] + 1, prev[j - 1] + cost);
        if (curr[j] < best) best = curr[j];
      }
      if (best > max) return max + 1;
      for (j = 0; j <= b.length; j++) prev[j] = curr[j];
    }
    return prev[b.length];
  }

  /* ¿Aparecen todas las letras en orden? Puntúa mejor cuanto más juntas estén,
     para que "cup" gane a un producto donde esas letras están desperdigadas. */
  function subsequenceScore(needle, haystack) {
    var i = 0;
    var j = 0;
    var first = -1;
    var last = -1;

    while (i < needle.length && j < haystack.length) {
      if (needle.charAt(i) === haystack.charAt(j)) {
        if (first < 0) first = j;
        last = j;
        i++;
      }
      j++;
    }
    if (i < needle.length) return 0;

    // Letras demasiado dispersas: coincidencia casual, no un acierto real.
    var span = last - first + 1;
    if (span > needle.length * 4) return 0;

    return Math.max(1, Math.round(60 * (needle.length / span)));
  }

  function wordScore(word, haystack, tokens) {
    if (!haystack) return 0;

    if (haystack === word) return 1000;

    var index = haystack.indexOf(word);
    if (index === 0) return 900;
    if (index > 0) {
      // Empezar palabra ("... cup") vale más que caer en mitad de una ("recup").
      return haystack.charAt(index - 1) === ' ' ? 820 : 640;
    }

    // Erratas: la tolerancia crece con la longitud para no convertir palabras
    // cortas en comodines ("sol" no debería encontrar "polo").
    var tolerance = word.length <= 3 ? 0 : word.length <= 5 ? 1 : 2;
    if (tolerance > 0) {
      for (var t = 0; t < tokens.length; t++) {
        var token = tokens[t];
        if (levenshtein(word, token, tolerance) <= tolerance) return 520;
        if (token.length > word.length) {
          // Errata en un prefijo: "gorr" vs "gorra" ya lo cubre indexOf, pero
          // "gora" no; se compara contra el trozo inicial del mismo largo.
          if (levenshtein(word, token.slice(0, word.length), tolerance) <= tolerance) return 470;
        }
      }
    }

    // Con una o dos letras la subsecuencia acierta en casi todo: solo vale la
    // subcadena, que ya se ha comprobado arriba.
    if (word.length < 3) return 0;

    var sub = subsequenceScore(word, haystack);
    return sub ? 200 + sub : 0;
  }

  function scoreItem(item, words) {
    var total = 0;

    for (var i = 0; i < words.length; i++) {
      var score = wordScore(words[i], item._t, item._tk);
      if (!score) {
        // Los campos secundarios (proveedor, tipo, etiquetas) cuentan menos que
        // el nombre para que un acierto en el título siempre suba primero.
        var extra = wordScore(words[i], item._x, item._xk);
        if (!extra) return 0;
        score = extra * 0.45;
      }
      total += score;
    }
    return total / words.length;
  }

  function prepareItems(list) {
    return (list || [])
      .filter(function (item) {
        return item && item.u;
      })
      .map(function (item) {
        var extra = [item.v, item.y, item.g].join(' ');
        item._t = normalize(item.t);
        item._tk = item._t ? item._t.split(' ') : [];
        item._x = normalize(extra);
        item._xk = item._x ? item._x.split(' ') : [];
        return item;
      });
  }

  function highlight(title, query) {
    var safe = escapeHtml(title);
    var needle = fold(query).trim();
    if (!needle) return safe;

    var folded = fold(title);
    // Si el plegado cambió la longitud, los índices ya no cuadran: sin resaltar.
    if (folded.length !== title.length) return safe;

    var index = folded.indexOf(needle);
    if (index < 0) return safe;

    return (
      escapeHtml(title.slice(0, index)) +
      '<mark class="bg-transparent font-bold text-brand-900">' +
      escapeHtml(title.slice(index, index + needle.length)) +
      '</mark>' +
      escapeHtml(title.slice(index + needle.length))
    );
  }

  function productCard(item, query) {
    var media = item.i
      ? '<img src="' +
        escapeHtml(item.i) +
        '" alt="" loading="lazy" class="absolute inset-0 h-full w-full object-cover transition-opacity duration-300 group-hover:opacity-80">'
      : '';
    var soldOut =
      item.a === false
        ? '<span class="absolute top-3 left-3 bg-white/95 px-2.5 py-1 text-[10.5px] leading-none text-brand-900">Agotado</span>'
        : '';
    var price = '<span>' + escapeHtml(item.p) + '</span>';
    if (item.c) price += '<s class="ml-1.5 text-stone-400">' + escapeHtml(item.c) + '</s>';

    return (
      '<a href="' +
      escapeHtml(item.u) +
      '" data-search-result class="group block focus:outline-none focus-visible:ring-2 focus-visible:ring-brand-900 focus-visible:ring-offset-4">' +
      '<div class="relative aspect-[4/5] overflow-hidden bg-stone-200">' +
      media +
      soldOut +
      '</div>' +
      '<h3 class="mt-3 text-[13px] leading-snug font-medium text-brand-900 md:text-[14px]">' +
      highlight(item.t, query) +
      '</h3>' +
      '<p class="mt-1 text-[12.5px] text-stone-500 md:text-[13px]">' +
      price +
      '</p>' +
      '</a>'
    );
  }

  function parseIndex(text) {
    try {
      var data = JSON.parse(text);
      return data && data.items ? data.items : [];
    } catch (error) {
      return [];
    }
  }

  /* Vistos recientemente — solo en el navegador del visitante. */
  function readRecent() {
    try {
      var raw = window.localStorage.getItem(RECENT_KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list : [];
    } catch (error) {
      return [];
    }
  }

  function writeRecent(list) {
    try {
      window.localStorage.setItem(RECENT_KEY, JSON.stringify(list));
    } catch (error) {
      /* Modo privado o almacenamiento lleno: se ignora sin romper nada. */
    }
  }

  function rememberProduct(item, max) {
    if (!item || !item.u) return;
    var list = readRecent().filter(function (entry) {
      return entry && entry.u !== item.u;
    });
    list.unshift(item);
    writeRecent(list.slice(0, max || 8));
  }

  var search = {
    root: null,
    input: null,
    items: [],
    pagesPending: false,
    lastFocus: null,
    maxResults: 24,
    recentCount: 8,
    activeIndex: -1,
    timer: null,

    init: function () {
      this.root = $('[data-search-modal]');

      // La lupa siempre abre algo: sin modal en la página, cae en /search.
      var self = this;
      document.addEventListener('click', function (event) {
        var opener = event.target.closest('[data-search-open]');
        if (opener && self.root) {
          event.preventDefault();
          self.open();
          return;
        }
        if (self.root && event.target.closest('[data-search-close]')) {
          event.preventDefault();
          self.close();
        }
      });

      this.trackProductView();
      if (!this.root) return;

      this.input = $('[data-search-input]', this.root);
      this.results = $('[data-search-results]', this.root);
      this.resultsBlock = $('[data-search-results-block]', this.root);
      this.allBlock = $('[data-search-all-block]', this.root);
      this.all = $('[data-search-all]', this.root);
      this.recentBlock = $('[data-search-recent]', this.root);
      this.recentList = $('[data-recent-list]', this.root);
      this.emptyMessage = $('[data-search-empty]', this.root);
      this.clearButton = $('[data-search-clear]', this.root);
      this.seeAll = $('[data-search-see-all]', this.root);
      this.body = $('[data-search-body]', this.root);
      this.maxResults = parseInt(this.root.dataset.maxResults, 10) || 24;
      this.recentCount = parseInt(this.root.dataset.recentCount, 10) || 8;

      this.loadIndex();

      this.input.addEventListener('input', function () {
        window.clearTimeout(self.timer);
        // 60 ms: lo justo para no re-pintar la rejilla en cada tecla.
        self.timer = window.setTimeout(function () {
          self.render();
        }, 60);
      });

      this.input.addEventListener('keydown', function (event) {
        if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {
          event.preventDefault();
          self.move(event.key === 'ArrowDown' ? 1 : -1);
          return;
        }
        if (event.key === 'Enter') {
          event.preventDefault();
          self.submit();
        }
      });

      if (this.clearButton) {
        this.clearButton.addEventListener('click', function () {
          self.input.value = '';
          self.input.focus();
          self.render();
        });
      }

      var recentClear = $('[data-recent-clear]', this.root);
      if (recentClear) {
        recentClear.addEventListener('click', function () {
          writeRecent([]);
          self.renderRecent();
        });
      }

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape' && self.isOpen()) {
          self.close();
          return;
        }
        // Atajo estándar de buscador: ⌘K / Ctrl+K.
        if ((event.metaKey || event.ctrlKey) && event.key.toLowerCase() === 'k') {
          event.preventDefault();
          self.isOpen() ? self.close() : self.open();
        }
      });
    },

    /* Registra la ficha que se está viendo (la publica main-product.liquid). */
    trackProductView: function () {
      var node = $('[data-recently-viewed]');
      if (!node) return;
      try {
        var item = JSON.parse(node.textContent);
        var max = this.root ? parseInt(this.root.dataset.recentCount, 10) || 8 : 8;
        rememberProduct(item, max);
      } catch (error) {
        /* JSON malformado: no vale la pena romper la página por esto. */
      }
    },

    loadIndex: function () {
      var self = this;
      var node = $('[data-search-index]');
      if (!node) return;

      this.items = prepareItems(parseIndex(node.textContent));
      this.renderAll();

      // Liquid no devuelve más de 50 productos por render. Si el catálogo es
      // mayor, el resto se pide a la sección `search-index` (una petición por
      // tramo) y se suma al índice ya cargado.
      var total = parseInt(node.getAttribute('data-total'), 10) || 0;
      var pages = Math.ceil(total / 50);
      if (pages < 2 || this.pagesPending) return;
      this.pagesPending = true;

      var requests = [];
      for (var page = 2; page <= pages; page++) {
        requests.push(
          fetch(rootUrl + '?section_id=search-index&page=' + page)
            .then(function (response) {
              return response.ok ? response.text() : '';
            })
            .then(function (text) {
              var fresh = text ? $('[data-search-index]', parseHTML(text)) : null;
              return fresh ? parseIndex(fresh.textContent) : [];
            })
            .catch(function () {
              // Sin los tramos extra el buscador sigue funcionando con los 50
              // primeros y "Ver todos los resultados" lleva a /search.
              return [];
            })
        );
      }

      Promise.all(requests).then(function (chunks) {
        var merged = self.items.slice();
        chunks.forEach(function (chunk) {
          merged = merged.concat(prepareItems(chunk));
        });
        var seen = {};
        self.items = merged.filter(function (item) {
          if (seen[item.u]) return false;
          seen[item.u] = true;
          return true;
        });
        self.renderAll();
        if (self.input && self.input.value.trim()) self.render();
      });
    },

    isOpen: function () {
      return this.root && !this.root.classList.contains('pointer-events-none');
    },

    open: function () {
      if (!this.root) return;
      this.lastFocus = document.activeElement;
      this.root.classList.remove('pointer-events-none');
      this.root.setAttribute('aria-hidden', 'false');

      var overlay = $('[data-search-overlay]', this.root);
      var panel = $('[data-search-panel]', this.root);
      if (overlay) overlay.classList.remove('opacity-0');
      if (panel) panel.classList.remove('opacity-0', '-translate-y-2');
      document.documentElement.classList.add('overflow-hidden');

      this.renderRecent();
      this.render();

      var self = this;
      window.setTimeout(function () {
        self.input.focus();
        self.input.select();
      }, 60);
    },

    close: function () {
      if (!this.root) return;
      var overlay = $('[data-search-overlay]', this.root);
      var panel = $('[data-search-panel]', this.root);
      if (overlay) overlay.classList.add('opacity-0');
      if (panel) panel.classList.add('opacity-0', '-translate-y-2');
      this.root.setAttribute('aria-hidden', 'true');
      document.documentElement.classList.remove('overflow-hidden');

      var self = this;
      window.setTimeout(function () {
        self.root.classList.add('pointer-events-none');
      }, 320);

      if (this.lastFocus && this.lastFocus.focus) this.lastFocus.focus();
    },

    query: function () {
      return this.input ? this.input.value.trim() : '';
    },

    match: function (query) {
      var words = normalize(query).split(' ').filter(Boolean);
      if (!words.length) return [];

      var scored = [];
      for (var i = 0; i < this.items.length; i++) {
        var score = scoreItem(this.items[i], words);
        if (score > 0) scored.push({ item: this.items[i], score: score, order: i });
      }
      scored.sort(function (a, b) {
        if (b.score !== a.score) return b.score - a.score;
        return a.order - b.order;
      });
      return scored.map(function (entry) {
        return entry.item;
      });
    },

    render: function () {
      if (!this.root) return;
      var query = this.query();
      this.activeIndex = -1;

      if (this.clearButton) this.clearButton.classList.toggle('hidden', !query);

      if (!query) {
        this.resultsBlock.classList.add('hidden');
        this.emptyMessage.classList.add('hidden');
        this.allBlock.classList.remove('hidden');
        if (this.recentBlock) this.recentBlock.classList.toggle('hidden', !readRecent().length);
        return;
      }

      var matches = this.match(query);
      if (this.recentBlock) this.recentBlock.classList.add('hidden');
      this.allBlock.classList.add('hidden');

      if (!matches.length) {
        this.resultsBlock.classList.add('hidden');
        var template = strings.search_no_results || 'No hemos encontrado nada para "%%TERMS%%".';
        this.emptyMessage.textContent = template.replace('%%TERMS%%', query);
        this.emptyMessage.classList.remove('hidden');
        return;
      }

      this.emptyMessage.classList.add('hidden');
      this.resultsBlock.classList.remove('hidden');
      $('[data-search-count]', this.root).textContent = matches.length;

      var visible = matches.slice(0, this.maxResults);
      this.results.innerHTML = visible
        .map(function (item) {
          return productCard(item, query);
        })
        .join('');

      if (this.seeAll) {
        var overflow = matches.length > visible.length;
        this.seeAll.classList.toggle('hidden', !overflow);
        this.seeAll.classList.toggle('inline-flex', overflow);
        this.seeAll.href = (routes.search_url || '/search') + '?q=' + encodeURIComponent(query);
      }

      if (this.body) this.body.scrollTop = 0;
    },

    renderAll: function () {
      if (!this.all) return;
      this.all.innerHTML = this.items
        .map(function (item) {
          return productCard(item, '');
        })
        .join('');
    },

    renderRecent: function () {
      if (!this.recentBlock || !this.recentList) return;
      // Se excluye la ficha que se está viendo: ya la tiene delante.
      var here = window.location.pathname;
      var list = readRecent()
        .filter(function (item) {
          return item && item.u && item.u.split('?')[0] !== here;
        })
        .slice(0, this.recentCount);
      if (!list.length) {
        this.recentBlock.classList.add('hidden');
        this.recentList.innerHTML = '';
        return;
      }
      this.recentBlock.classList.remove('hidden');
      this.recentList.innerHTML = list
        .map(function (item) {
          return productCard(item, '');
        })
        .join('');
    },

    /* Navegación con flechas por la rejilla visible. */
    cards: function () {
      var container = this.query() ? this.results : this.allBlock;
      return $$('[data-search-result]', container);
    },

    move: function (delta) {
      var cards = this.cards();
      if (!cards.length) return;
      this.activeIndex += delta;
      if (this.activeIndex < 0) this.activeIndex = cards.length - 1;
      if (this.activeIndex >= cards.length) this.activeIndex = 0;
      cards[this.activeIndex].focus();
      cards[this.activeIndex].scrollIntoView({ block: 'nearest' });
    },

    submit: function () {
      var cards = this.cards();
      if (cards.length) {
        window.location.href = cards[Math.max(0, this.activeIndex)].href;
        return;
      }
      var query = this.query();
      if (query) window.location.href = (routes.search_url || '/search') + '?q=' + encodeURIComponent(query);
    }
  };

  /* ----------------------------------------------------------------------
     9. Selectores de localización — snippets/localization-selector.liquid

     El componente ya funciona sin esto: es un <details> con botones submit
     dentro del formulario de localización de Shopify, así que abre, cierra y
     envía por sí solo. Aquí solo se añade lo que <details> no trae de serie y
     que se espera de un desplegable: cerrarse al hacer clic fuera, cerrarse con
     Escape, que no queden dos abiertos a la vez y moverse con las flechas.

     Las escuchas se enganchan al propio <details>, no a document, salvo la del
     clic fuera, que por definición ocurre en cualquier parte de la página.
  ---------------------------------------------------------------------- */
  var localizationSelectors = {
    init: function () {
      var roots = $$('[data-localization]');
      if (!roots.length) return;

      var self = this;

      roots.forEach(function (root) {
        var details = $('[data-localization-details]', root);
        if (!details) return;

        details.addEventListener('toggle', function () {
          if (!details.open) return;
          self.closeOthers(details);
          // Con un mercado de muchos países la opción activa puede quedar fuera
          // de la parte visible del panel.
          var current = $('[data-localization-option][aria-current="true"]', details);
          if (current) current.scrollIntoView({ block: 'nearest' });
        });

        details.addEventListener('keydown', function (event) {
          self.onKeydown(event, details);
        });
      });

      // Clic fuera. Cubre también la hamburguesa, el buscador y el carrito: al
      // abrir cualquier otra cosa el desplegable se cierra solo, sin necesitar
      // un manejador por caso.
      document.addEventListener('click', function (event) {
        self.open().forEach(function (details) {
          if (!details.contains(event.target)) details.open = false;
        });
      });
    },

    open: function () {
      return $$('[data-localization] [data-localization-details][open]');
    },

    closeOthers: function (keep) {
      this.open().forEach(function (details) {
        if (details !== keep) details.open = false;
      });
    },

    onKeydown: function (event, details) {
      if (event.key === 'Escape') {
        if (!details.open) return;
        details.open = false;
        var summary = $('summary', details);
        if (summary) summary.focus();
        return;
      }

      if (!details.open) return;
      if (['ArrowDown', 'ArrowUp', 'Home', 'End'].indexOf(event.key) === -1) return;

      var options = $$('[data-localization-option]', details);
      if (!options.length) return;

      event.preventDefault();
      var index = options.indexOf(document.activeElement);
      var next;

      if (event.key === 'Home') {
        next = 0;
      } else if (event.key === 'End') {
        next = options.length - 1;
      } else if (event.key === 'ArrowDown') {
        next = index < 0 ? 0 : (index + 1) % options.length;
      } else {
        next = index <= 0 ? options.length - 1 : index - 1;
      }

      options[next].focus();
      options[next].scrollIntoView({ block: 'nearest' });
    }
  };

  /* ----------------------------------------------------------------------
     Init
  ---------------------------------------------------------------------- */
  function init() {
    drawer.init();
    initAjaxAdd();
    initCardVariants();
    initSteppers();
    initCartLines();
    search.init();
    localizationSelectors.init();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
